"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var PrintTour = /*#__PURE__*/function (_Vue) {
  function PrintTour() {
    var _this;
    (0, _classCallCheck2.default)(this, PrintTour);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PrintTour, [].concat(args));
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "data", {});
    (0, _defineProperty2.default)(_this, "listOrder", []);
    return _this;
  }
  (0, _inherits2.default)(PrintTour, _Vue);
  return (0, _createClass2.default)(PrintTour, [{
    key: "handleView",
    value: function handleView(data) {
      this.visible = true;
      var shipFeePersonal = data.tour.moneyShipFee / data.shipperIds.length;
      this.data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        shipFeePersonal: Math.round(shipFeePersonal / 1000) * 1000
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
PrintTour = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], PrintTour);
var _default = exports.default = PrintTour;